// extracted by mini-css-extract-plugin
export default {"button":"FacebookAuth_button__y4tCh","buttonLabel":"FacebookAuth_buttonLabel__bP2Rk"};